import { Button, Menu, MenuRootProps } from "@ttc3k/trekker";
import { NavArrowLeft, NavArrowRight } from "iconoir-react";
import { useState } from "react";
import { Flex } from "styled-system/jsx";

type ProgressStep = {
  label: string;
  disabled?: boolean;
};

type ProgressStepperProps = {
  currentStep: number;
  steps: ProgressStep[];
  isLoading: boolean;
  disabled?: boolean;
  menuProps?: Omit<
    MenuRootProps,
    "trigger" | "open" | "onOpenChange" | "onSelect"
  >;
  onJumpToStepClick: (index: number) => void;
  onPreviousClick: () => void;
  onNextClick: () => void;
};

export const ProgressStepper = ({
  currentStep,
  steps,
  isLoading,
  disabled = false,
  menuProps,
  onJumpToStepClick,
  onPreviousClick,
  onNextClick,
}: ProgressStepperProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Flex alignItems="center" gap="75">
      <Button
        visual="primary"
        mode="light"
        size="sm"
        disabled={currentStep === 1 || disabled}
        isLoading={isLoading}
        onClick={onPreviousClick}
        Icon={NavArrowLeft}
      />
      <Menu.Root
        open={isOpen}
        onOpenChange={details => setIsOpen(details.open)}
        trigger={
          <Button
            visual="primary"
            mode="light"
            size="sm"
            w="70px"
            disabled={disabled}
          >
            {`${currentStep} / ${steps.length}`}
          </Button>
        }
        onSelect={({ value }: { value: string }) =>
          onJumpToStepClick(Number(value))
        }
        {...menuProps}
      >
        {steps.map((step, index) => (
          <Menu.Item
            key={step.label}
            value={(index + 1).toString()}
            disabled={step.disabled || isLoading || disabled}
          >
            {step.label}
          </Menu.Item>
        ))}
      </Menu.Root>
      <Button
        visual="primary"
        mode="light"
        size="sm"
        disabled={currentStep === steps.length || disabled}
        isLoading={isLoading}
        onClick={onNextClick}
        Icon={NavArrowRight}
      />
    </Flex>
  );
};
